import React from "react";
import { useForm } from "react-hook-form";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../utils/components/ui/dialog";
import { Button } from "../../utils/components/ui/button";
import {
  useGetQuotationById,
  useQuotationPaid,
  useUpdateQuotation,
} from "../../service/quatationService";
import { toast } from "react-toastify";
import { useAddInvoice } from "../../service/invoiseService";
import { AxiosError } from "axios";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import Loading from "../common/LoaderCommon";
import { quotaionEditBody } from "../../types/quatationType";
import { useNavigate } from "react-router-dom";

interface DraftToQuotationModalProps {
  open: boolean;
  onCancel: () => void;
  onContinue?: (data: { actualAmount: string; lpoNumber: string }) => void;
  onClose?: () => void; // new prop for handle close
  id?: any;
  setId: (data: string) => void; // optional prop for setting quote data
}

export const DraftToQuotationModal: React.FC<DraftToQuotationModalProps> = ({
  open,
  onCancel,
  onContinue,
  onClose,
  id,
  setId,
}) => {
  const queryClient = useQueryClient();

  const { data: Draft, isLoading } = useGetQuotationById(id);
  const navigate = useNavigate();
  console.log(Draft, "Draft in DraftToQuotationModal");
  const convertToQuotation = useUpdateQuotation({
    onSuccess: (data) => {
      console.log("Mutation response:", data);
      toast.success("Success");
      setId("");
      navigate("/sales/quatation");
      queryClient.invalidateQueries({ queryKey: ["useGetAllQuotation"] });
      if (onClose) onClose();
    },
    onError: (error: Error) => {
      console.error("Error saving invoice:", error);
      toast.error(`Failed to save invoice: ${error.message}`);
    },
  });

  const handleSubmit = () => {
    let productRequests = Draft?.quotationProducts?.map((item) => {
      return {
        ...item,
        id: item?.id,
        productId: item?.product?.id,
        quantity: item?.qty,
        discountAmount: item?.discountAmount,
        isDiscountPercentage: true,
        taxPercentage: item?.rateOfTax,
      };
    });

    let postData: quotaionEditBody = {
      customerId: Draft?.customer?.id,
      quotationProductRequests: productRequests,
      isDraft: false,
      id: Draft?.id,
    };
    convertToQuotation.mutate(postData);
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-md w-full">
        {isLoading ? (
          <Loading />
        ) : (
          <DialogHeader>
            <DialogTitle className="text-[#1A5EF9] text-2xl font-bold mb-2">
              Are you sure ?
            </DialogTitle>
            <div className="text-gray-600 text-base font-bold mb-6">
              {Draft?.quotationNumber
                ? ` Convert the draft :${Draft?.quotationNumber} to quotation`
                : ` Convert the draft  to quotation`}
            </div>
          </DialogHeader>
        )}

        <DialogFooter className="flex flex-row gap-4 mt-6">
          <Button
            type="button"
            variant="outline"
            className="w-1/2 text-lg font-semibold"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSubmit()}
            className="w-1/2 bg-[#1A5EF9] text-white text-lg font-semibold hover:bg-[#7bb11c]"
            disabled={convertToQuotation.status === "pending"}
          >
            {convertToQuotation.status === "pending"
              ? "Loading..."
              : "Continue"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DraftToQuotationModal;
